import "../css/header.scss";
import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { CartContext } from "./CartContext";

function Header() {
  const { cartItems } = useContext(CartContext);
  const cartCount = cartItems.reduce((total, item) => total + item.quantity, 0);

  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <header className="site-header">
      <div className="header-top-banner">
        <div className="banner-content">
          <span className="banner-icon">🍾</span>
          <span className="banner-text">
            End Soon! Save up to 30% off bottles of English Sparkling
          </span>
        </div>
      </div>

      <div className="header-main">
        <div className="header-center">
          <Link to="/" className="logo-link" onClick={toTop}>
            <img
              className="brand-logo"
              src="/failblossom-logo.svg"
              alt="failblossom"
            />
          </Link>
        </div>

        <div className="header-right">
          <div className="currency-selector">
            <span className="flag">🇬🇧</span>
            <span className="currency">GB / £ GBP</span>
          </div>

          <div className="user-icons">
            <Link to="/cartpage" className="icon-link cart-icon">
              <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
              >
                <circle cx="9" cy="21" r="1" />
                <circle cx="20" cy="21" r="1" />
                <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6" />
              </svg>
              {cartCount > 0 && <span className="cart-count">{cartCount}</span>}
            </Link>
          </div>
        </div>
      </div>

      <nav className="header-nav">
        <ul className="nav-list">
          <li>
            <Link to="/shop" onClick={toTop}>
              New In
            </Link>
          </li>
          <li>
            <Link to="/about" onClick={toTop}>
              About Us
            </Link>
          </li>
          <li>
            <Link to="/contact" onClick={toTop}>
              Help
            </Link>
          </li>
          <li className="more-menu">
            <button type="button" className="more-trigger" aria-haspopup="true">
              More <span aria-hidden="true">⌄</span>
            </button>
            <ul className="more-dropdown" aria-label="More information">
              <li><Link to="/privacy" onClick={toTop}>Privacy Policy</Link></li>
              <li><Link to="/cookies" onClick={toTop}>Cookie Policy</Link></li>
              <li><Link to="/terms" onClick={toTop}>Terms of Use</Link></li>
              <li><Link to="/faqs" onClick={toTop}>FAQs</Link></li>
              <li><Link to="/returns" onClick={toTop}>Returns Policy</Link></li>
              <li><Link to="/shipping" onClick={toTop}>Delivery Information</Link></li>
            </ul>
          </li>
        </ul>
      </nav>
    </header>
  );
}

export default Header;
